export default "__VITE_ASSET__B3nHG4fn__"